import React, { useState, useEffect } from 'react';
import { Divider } from 'antd';

import { ActionType } from '../../index';

export interface PropsType {
  action?: ActionType;
  onEdit?: () => void;
  onOk?: () => void;
  onCancel?: () => void;
  edit?: boolean;
}

const BlockEdit: React.FC<PropsType> = (props: PropsType) => {
  const { action, onEdit, onOk, onCancel, edit } = props;
  const [editor, setEditor] = useState(false);

  const handleChange = (flag: boolean) => {
    if (typeof edit !== 'undefined') {
      setEditor(edit);
    } else {
      setEditor(flag);
    }
  };

  const renderActiton = (): JSX.Element | string | ActionType => {
    if (typeof action === 'string') {
      return action;
    }

    if (typeof action === 'function') {
      return action(editor);
    }

    return editor ? (
      <>
        <a
          onClick={() => {
            onCancel && onCancel();
            handleChange(false);
          }}>
          {'取消'}
        </a>
        <Divider type="vertical" />
        <a
          onClick={() => {
            onOk && onOk();
            handleChange(false);
          }}>
          {'保存'}
        </a>
      </>
    ) : (
      <>
        <a
          className="block-edit"
          onClick={() => {
            onEdit && onEdit();
            handleChange(true);
          }}>
          {'编辑'}
        </a>
      </>
    );
  };

  useEffect(() => {
    if (typeof edit !== 'undefined') {
      setEditor(edit);
    }
  }, [edit]);

  return (
    <div className="block-edit-box" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
      {renderActiton()}
    </div>
  );
};

export default BlockEdit;
